import {CheckpointOnshoreFacilityPersonFragmentFragment} from "../../__generated__/graphql/types";
import moment from 'moment-timezone';
import {Icon, Tooltip, Typography} from "antd";
import {OUT_OF_COMPLIANCE_DAYS_THRESHOLD} from "./constant";

export type NextExpirationDateProps =  {
    date?: string,
    thresholdDays?: number
}

export function NextExpirationDate({ date, thresholdDays=OUT_OF_COMPLIANCE_DAYS_THRESHOLD }: NextExpirationDateProps) {

    const na = <Typography.Text type="secondary">N/A</Typography.Text>;

    function renderDate(dateStr: string | null) {
        if (!dateStr) {
            return na
        }
        const date = moment(dateStr);
        if (!date.isValid()) {
            return na
        }

        const now = moment();

        if (date.isSameOrBefore(now)){
            const daysDiff = now.diff(date, 'days');
            // Out of compliance
            return <Tooltip title={`Expired for ${daysDiff} days`}>
                <span>
                    <span style={{ marginRight: 6 }}>
                        <Typography.Text type="danger"><Icon type="exclamation-circle" /></Typography.Text>
                    </span>
                    <Typography.Text type="danger">
                        {dateStr}
                    </Typography.Text>
                </span>
            </Tooltip>
        }
        if (date.isBefore(now.clone().add(thresholdDays, 'days'))) {
            const daysDiff = date.diff(now, 'days');
            // Almost out of compliance
            return <Tooltip title={`Expires in ${daysDiff} days`}>
                <span>
                    <span style={{ marginRight: 6 }}>
                        <Typography.Text type="warning"><Icon type="warning" /></Typography.Text>
                    </span>
                    <Typography.Text type="warning">
                        {dateStr}
                    </Typography.Text>
                </span>
            </Tooltip>
        }

        const daysDiff = date.diff(now, 'days');

        // In compliance
        return <Tooltip title={`Expires in ${daysDiff} days`}>
                <span style={{ color: 'green' }}>
                    <span style={{ marginRight: 6 }}>
                        <Icon type="check" />
                    </span>
                    <span>{dateStr}</span>
                </span>
        </Tooltip>
    }

    if (!date){ return na; }

    return renderDate(date);
}